import React, { useEffect } from 'react';
import './App.css';
import { useLoading } from './LoadingContext';
import { injectLoadingHandler } from './api';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { loading, setLoading } = useLoading();

  useEffect(() => {
    injectLoadingHandler(setLoading);
  }, [setLoading]);

  return (
    <div className="App">
      {/* {loading && <div className="loading-bar" />} */}
      {/* Other app content */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}

export default App;
